var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.526345 14C-0.888948 14 0.99813 12.3331 0.99813 12.3331L1.94164 10.1899L3.82872 12.095L1.94164 13.0475H8.0746L9.01811 14H0.526345ZM5.24398 11.6187H4.30047L2.41342 9.7137V8.76118L5.24398 11.6187ZM4.46202 7.49551C3.85315 8.19756 3.64759 8.76967 3.47489 9.11838L3.00311 8.64213C3.00311 8.64213 2.41342 8.28494 3.82872 6.85617L4.46202 7.49551ZM5.36194 11.0234L3.82869 9.47557C4.10212 8.99252 4.27833 8.42947 4.78319 7.81976L7.13106 10.1899C7.13106 10.1899 5.8337 11.4997 5.36194 11.0234ZM5.21922 7.30742C7.21714 5.01827 10.3814 2.35725 12.3025 0.663543C12.9353 1.18876 13.5055 1.78809 14 2.44839L7.60281 9.7137L5.21922 7.30742ZM11.4102 0L11.85 0.308616C9.905 2.08241 6.79315 4.8944 4.90696 6.99219L4.30047 6.3799L11.4102 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillIcon);
export default __webpack_public_path__ + "static/media/fill_icon.c72add7e53ec58413acc863d79cd7ece.svg";
export { ForwardRef as ReactComponent };